<!-- 对应卡 -->
<template>
  <div>
    <div class="chat-card">
      <img src="@/assets/images/deal_with_the_list_icon.png" alt="icon">
      <div class="content">
        <div class="label">我遇到的情境：</div>
        <div class="value">
          <input type="text" :disabled="!isCanEdit" v-model="addObject.sitText" placeholder="在这里输入内容">
        </div>
        <div class="label">我应该：</div>
        <div class="value">
          <input type="text" :disabled="!isCanEdit" v-model="addObject.replyText" placeholder="在这里输入内容">
        </div>
        <button class="confirm-btn" v-if="isCanEdit" @click="confirmFn">确定</button>
      </div>
    </div>
    <!-- <div class="send-time">09月01日  16:29</div> -->
  </div>
</template>

<script>
export default {
  name: 'ChatStrategyCard',
  components: {},
  props: {
    cardData: {
      type: Object,
      default: () => {
        return null;
      },
    },
    // 是否可编辑
    isCanEdit: {
      type: Boolean,
      default: true,
    },
    nextData: {
      type: Object,
      default: () => {
        return null;
      },
    }
  },
  data() {
    return {
      addObject: {
        sitTitle: '我遇到的情境',
        replyTitle: '我应该',
        sitText: '',
        replyText: ''
      },
    };
  },
  created() {},
  mounted() {
    if(this.nextData?.step_data?.survey?.qstList[0].answer) {
      let useData = this.nextData.step_data.survey.qstList[0].answer;
      this.addObject = useData;
    }
  },
  methods: {
    confirmFn() {
      const useData = {
        id: this.cardData.id,
        step_id: this.cardData.step_id,
        step_data: {
          survey: {
            id: this.cardData.instance_id,
            surveyType: 2,
            qstList: [
              {
                qstCode: this.cardData.step_type,
                answer: this.addObject,
              },
            ],
          },
        },
      };
      this.$emit('confirmFn', useData);
    },
  },
};
</script>

<style scoped lang="scss">
.chat-card {
  width: 100%;
  border-radius: 12px;
  padding: 16px 12px;
    padding: 14px 17px;
  background: #e8e3fc;
  box-sizing: border-box;
  display: flex;
  img {
    width: 24px;
    height: 24px;
    font-size: 0;
  }
  .content {
    margin-left: 6px;
    flex: 1;
    font-size: 12px;
    font-weight: 500;
    line-height: 15.91px;
    color: rgba(40, 28, 54, 1);
    text-align: left;
  }
  .datetime {
    margin-top: 12px;
    font-size: 10px;
    font-weight: 400;
    line-height: 20px;
    color: rgba(157, 159, 163, 1);
    text-align: right;
    vertical-align: top;
  }
  .label {
    font-size: 12px;
    font-weight: 500;
    color: rgba(40, 28, 54, 1);
    text-align: left;
    margin-bottom: 10px;
  }
  .value {
    margin-bottom: 10px;
    input {
      width: 100%;
      box-sizing: border-box;
      padding: 1px 8px;
      border: none;
      border-radius: 6px;
      background: rgba(255, 255, 255, 1);
      font-size: 10px;
      font-weight: 400;
      line-height: 23px;
      text-align: left;
      vertical-align: top;
    }
  }
  .confirm-btn {
    width: 75.94px;
    height: 25.31px;
    border-radius: 12.66px;
    background: #ad7eff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10.13px;
    font-weight: 400;
    letter-spacing: 0.23px;
    color: rgba(255, 255, 255, 1);
    border: none;
    margin: 10px auto 0;
  }
}
.send-time {
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20px;
  color: #9d9fa3;
  margin-top: 4px;
}
</style>
